  import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHeadTypes} from "../../constants";

export default class DiverterTrim extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'diverter_trim';
    this.partName = 'Diverter Trim';
    this.translateId = "visualizer.bathroom.shower.diverter_trim";
    this.canBeDisabled = true;
    this.disabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    this.setArmHeadType();
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    // if (!showerParent.valveTrim
    //   || !showerParent.valveTrim.activeFeature
    //   || showerParent.valveTrim.disabled
    //   || !showerParent.valveTrim.activeFeature.metaData?.["ValveType"]?.includes("Single")
    // ) {
    //   return true
    // }
    const showerTubComboParent = showerParent.layout.parts["Shower Tub Combo"];
    if (showerTubComboParent?.showerTubComboIsActive && showerTubComboParent.bottomTub === "walk_in_tub") {
      return true // QCDES-8175
    }
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm && !(
      showerTubComboParent?.showerTubComboIsActive && showerTubComboParent.replacementTubFixture
      && !showerTubComboParent.replacementTubFixture.disabled
      && showerTubComboParent.replacementTubFixture.activeFeature
      && Object.keys(showerTubComboParent.replacementTubFixture.layerPositions).some(pos => {
        return showerTubComboParent.replacementTubFixture.layerPositions[pos]
      })
    )
  }

  getArrayOfConditions() {
    // const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent();
    // if (!showerParent.valveTrim
    //   || !showerParent.valveTrim.activeFeature
    //   || showerParent.valveTrim.disabled
    //   || !showerParent.valveTrim.activeFeature.metaData?.["ValveType"]?.includes("Single")
    // ) {
    //   return [{propName: "Hide", propValue: ["Hide"]}]
    // }
    return showerParent.valveTrim.getArrayOfConditions() // Placement, ShowerSize, RoomLayout, RoomScene
    // return conditions;
  }

}
